import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import Sortable from 'sortablejs';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-kanban-todolist', {
  mixins: [eventListenerMixin],

  properties: {
    todoCount: {
      type: Number,
      observer: 'todoCountChanged',
    },
    unloadTodoCount: {
      type: Number,
    },
    guid: String,
  },

  ready() {
    this.initSortTodo();
  },

  initSortTodo() {
    if (this.classList.contains('todolist-placeholder')) return;

    [...this.querySelectorAll('.todos-container .todos')].forEach((container) => {
      Sortable.create(container, {
        group: 'kanban-card-todo',
        sort: true,
        draggable: 'tr-kanban-todo',
        animation: 0,
        emptyInsertThreshold: 78,
        forceFallback: (window.gon && window.gon.sortableFallback) || false,
        onEnd: (event) => {
          const todosContainer = closest(event.to, '.todos-container');
          if (event.item.completed && event.to.classList.contains('todos-uncompleted')) {
            const appendedNode = todosContainer.querySelector('.todos-completed');
            appendedNode.appendChild(event.item);
          }

          if (!event.item.completed && event.to.classList.contains('todos-completed')) {
            const appendedNode = todosContainer.querySelector('.todos-uncompleted');
            appendedNode.appendChild(event.item);
          }

          const $todo = $(event.item);
          $.ajax({
            url: $todo.attr('reorder-url'),
            type: 'post',
            dataType: 'script',
            data: {
              todolist_guid: $todo.closest('tr-kanban-todolist').attr('guid'),
              prev_todo_guid: $todo.prev('tr-kanban-todo').attr('guid'),
              next_todo_guid: $todo.next('tr-kanban-todo').attr('guid'),
            },
          });
        },
      });
    });
  },

  todoCountChanged() {
    const title = this.querySelector('tr-kanban-todolist-title');
    if (title) title.syncTodoCount();
  },

  updateTodoCount() {
    this.todoCount = this.querySelectorAll(
      '.tr-kanban-todo',
    ).length + this.unloadTodoCount;
  },

  disconnected() {
    this.stopListening();
  },
});
